import React from 'react';
import { useIntl } from 'react-intl';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.hypedirector.fan&pli=1';
const APPLE_APPSTORE_URL = 'https://apps.apple.com/us/app/hypedirector/id6763227059';
const SHOW_APP_STORE_BUTTONS = import.meta.env.VITE_ENVIRONMENT === 'prod';
const GOOGLE_PLAY_BADGE_URL = 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
const APP_STORE_BADGE_URL = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';

const appStoreBadgeStyle: React.CSSProperties = {
  height: 56,
  width: 'auto',
  display: 'block',
  transition: 'opacity 0.15s',
  cursor: 'pointer',
};

const googlePlayBadgeStyle: React.CSSProperties = {
  ...appStoreBadgeStyle,
  // Google's official PNG includes transparent padding around the badge.
  // Render it taller so the visible badge matches the App Store badge height.
  height: 82,
};

interface AppStoreButtonsProps {
  className?: string;
}

export const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({ className }) => {
  const intl = useIntl();

  if (!SHOW_APP_STORE_BUTTONS) {
    return null;
  }

  return (
    <div className={className} style={{ display: 'flex', gap: '12px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
      <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
        <img
          src={GOOGLE_PLAY_BADGE_URL}
          alt={intl.formatMessage({ id: 'landing.badges.googlePlay' })}
          style={googlePlayBadgeStyle}
        />
      </a>
      <a href={APPLE_APPSTORE_URL} target="_blank" rel="noopener noreferrer">
        <img
          src={APP_STORE_BADGE_URL}
          alt={intl.formatMessage({ id: 'landing.badges.appStore' })}
          style={appStoreBadgeStyle}
        />
      </a>
    </div>
  );
};
